import { get, post } from "./fetch";

export const getTrialSubscription = (page, rowsPerPage, categorySEOName, marketID, sellerID) => {
    return post(`/api/manager/subscriptions/trial`, {categorySEOName: categorySEOName, market: marketID, page: page, rowsPerPage: rowsPerPage, sellerID: sellerID}, true);
}

export const getSubscriptionStatus = () => {
    return get(`/api/subscription/status`, true)
}
export const getSubscribableCategories = (sellerID) => {
    return get(`/api/manager/seller/${sellerID}/subscribable/categories`, true);
}

export const getPlansByCategoryID = (categoryID) => {
    return get(`/api/manager/category/${categoryID}/plans`, true);
}

export const getTrialConfiguration = () => {
    return get(`/api/manager/configuration/trial`, true);
}

export const searchTrialSellers = (searchTerm) => {
    return post(`/api/manager/subscriptions/trial/search`, {searchTerm});
}
